<div class="FormElement has-fixedAddon">
  <span class="FormElement-label">{{ label }}:</span>
  <div class="FormElement-control">
    <div class="FormElement-control alignItems">
      <app-percentage-edit
        [(isDirty)]="childIsDirty[0]"
        (valueChange)="onChange()"
        [editMode]="editMode"
        [disable]="disable"
        [allowDecimal]="true"
        [(value)]="firstValue"
      ></app-percentage-edit>
      <span class="FormElement-addon">/</span>
      <app-percentage-edit
        [(isDirty)]="childIsDirty[1]"
        (valueChange)="onChange()"
        [editMode]="editMode"
        [disable]="disable"
        [allowDecimal]="true"
        [(value)]="secondValue"
      ></app-percentage-edit>
    </div>
  </div>
</div>
